// extracted by mini-css-extract-plugin
export default {"max-w-span":"link_max-w-span__0ihM6","min-w-span":"link_min-w-span__9zL-K","min-w-img":"link_min-w-img__37qP-","h-40px":"link_h-40px__xppaf","link-image":"link_link-image__nr-P1"};